import React              from 'react';
import DisplayStatusDCBox from './DisplayStatusDCBox';

function DisplayStatusDCRow( { key, row } ) {
    
    return(<> 
             { row ? (<> 
               { row.map( (rec, index ) => (
                   <DisplayStatusDCBox key={index} rec={rec}/> ))} 
               </>) : (<>Loading...</>) }
           </>);
}

export default DisplayStatusDCRow;
